/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
import Vue from 'vue';
import VueClipboard from 'vue-clipboard2';
import Bootstrap from './bootstrap';
import {initHamburgerMenu} from './initHamburgerMenu';
import {initSidebar} from './initSidebar';
import {initAnimations} from './initAnimations';

import { library } from '@fortawesome/fontawesome-svg-core';
// Be super specific for the icons we are importing from fontawesome so our build times and compiled asset size is minimized.
// Note: You should add the name of the icon to both the import list below AND the "solidIcons" or "brandIcons" array.
// https://fontawesome.com/how-to-use/javascript-api/setup/importing-icons
import { faShieldAlt, faLongArrowAltDown, faLongArrowAltRight, faInfoCircle, faBars, faTimes, faCircleNotch, faCog, faSyncAlt, faChartBar, faSignInAlt, faSignOutAlt, faAngleDoubleRight, faFire, faGamepad, faUserCircle, faQuestionCircle, faLock, faFileAlt, faUserSecret, faHome, faBan, faThumbtack, faBullhorn, faCheck, faShoppingCart, faCreditCard, faTrashAlt, faTimesCircle, faCopy, faMoneyCheck, faFilePdf, faExclamationCircle, faComment, faPlug, faLink, faPaperclip, faUsers, faCommentAlt, faComments, faClock, faCaretDown, faUser, faRandom, faUserPlus, faEdit, faTrash, faSearch, faHashtag, faExchangeAlt, faDollarSign, faTrophy, faPaperPlane, faSpinner, faGift, faHdd, faMicrophone, faMobileAlt, faEuroSign } from '@fortawesome/free-solid-svg-icons';
import { faGuilded, faDiscord, faConnectdevelop , faTwitter, faPaypal, faWindows, faUnity, faCcVisa, faCcAmex, faCcDiscover, faCcJcb, faCcPaypal, faCcDinersClub, faCcAmazonPay, faCcMastercard, faCcStripe, faCcApplePay } from '@fortawesome/free-brands-svg-icons';
// Gives us the <font-awesome-icon> component instead of adding icons with <i> tags.
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

// "FAS" Font Awesome Icons
const solidIcons = [ faShieldAlt, faLongArrowAltDown, faLongArrowAltRight, faInfoCircle, faBars, faTimes, faCircleNotch, faCog, faSyncAlt, faChartBar, faSignInAlt, faSignOutAlt, faAngleDoubleRight, faFire, faGamepad, faUserCircle, faQuestionCircle, faLock, faFileAlt, faUserSecret, faHome, faBan, faThumbtack, faBullhorn, faCheck, faShoppingCart, faCreditCard, faTrashAlt, faTimesCircle, faCopy, faMoneyCheck, faFilePdf, faExclamationCircle, faComment, faPlug, faLink, faPaperclip, faUsers,faCommentAlt, faComments, faClock, faCaretDown, faUser, faRandom, faUserPlus, faEdit, faTrash, faSearch, faHashtag, faExchangeAlt, faDollarSign, faTrophy, faPaperPlane, faSpinner, faGift, faHdd, faMicrophone, faMobileAlt, faEuroSign ];
// "FAB" Font Awesome Icons
const brandIcons = [ faPaypal, faGuilded, faDiscord, faTwitter, faConnectdevelop, faWindows, faUnity, faCcVisa, faCcAmex, faCcDiscover, faCcJcb, faCcPaypal, faCcDinersClub, faCcAmazonPay, faCcMastercard, faCcStripe, faCcApplePay ];
library.add(...brandIcons, ...solidIcons);

import PopperTooltip from './components/PopperTooltip.vue';
import SetupInstructions from './components/SetupInstructions.vue';
import CopyToClipboard from './components/CopyToClipboard.vue';
import Trianglify from './components/Triangles.vue';
import ConfirmTooltip from './components/ConfirmTooltip';
import FormSelect from './components/FormSelect';

import * as EVENTS from './events';

window.Vue = Vue;

Bootstrap.bugsnag();

Vue.use(VueClipboard);

Vue.component('trianglify', Trianglify);
Vue.component('modal', { template: '#modal-template' });
Vue.component('setup-instructions', SetupInstructions);
Vue.component('copy-to-clipboard', CopyToClipboard);
Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('popper-tooltip', PopperTooltip);
Vue.component('confirm-tooltip', ConfirmTooltip);

const pageClasses = document.getElementById('app');
if (pageClasses.classList.contains('page-guild-config')) {
    Vue.component('game-profile', () => import(/* webpackChunkName: "guild" */ './components/guild-subscriptions/GameProfile.vue'));
    Vue.component('send-last-update', () => import(/* webpackChunkName: "guild" */ './components/guild-subscriptions/channel-settings/SendLastUpdate.vue'));
    Vue.component('pin-updates', () => import(/* webpackChunkName: "guild" */ './components/guild-subscriptions/channel-settings/PinUpdates.vue'));
    Vue.component('channel-subscription-list', () => import(/* webpackChunkName: "guild" */ './components/guild-subscriptions/ChannelSubscriptionList.vue'));
    Vue.component('channel-subscription-slider', () => import(/* webpackChunkName: "guild" */ './components/guild-subscriptions/ChannelSubscriptionSlider.vue'));
    Vue.component('game-search', () => import(/* webpackChunkName: "guild" */ './components/guild-subscriptions/GameSearch.vue'));
    Vue.component('dismissable', () => import(/* webpackChunkName: "guild" */ './components/Dismissable.vue'));
    Vue.component('channel-option', () => import(/* webpackChunkName: "guild" */ './components/guild-subscriptions/ChannelOption.vue'));
    Vue.component('channel-options-global', () => import(/* webpackChunkName: "guild" */ './components/guild-subscriptions/ChannelOptionsGlobal.vue'));
    Vue.component('interestToggles', () => import(/* webpackChunkName: "guild" */ './components/guild-subscriptions/premium-settings/InterestToggles.vue'));
    Vue.component('activity-log', () => import(/* webpackChunkName: "guild" */ './components/guild-subscriptions/ActivityLog.vue'));
    Vue.component('form-select', FormSelect);
    Vue.component('category-select', () => import(/* webpackChunkName: "guild" */ './components/guild-subscriptions/CategorySelect.vue'));
    Vue.component('mini-games-list', () => import(/* webpackChunkName: "guild" */ './components/guild-subscriptions/MiniGamesList.vue'));
    Vue.component('confirm-tooltip', () => import(/* webpackChunkName: "guild" */ './components/ConfirmTooltip.vue'));
} else if (pageClasses.classList.contains('page-billing')) {
    Vue.component('manage-payment-method', () => import(/* webpackChunkName: "billing" */ './components/billing/ManagePaymentMethod.vue'));
    Vue.component('form-select', FormSelect);
} else if (pageClasses.classList.contains('page-premium')) {
    Vue.component('server-grid', () => import(/* webpackChunkName: "billing" */ './components/billing/ServerGrid.vue'));
    Vue.component('change-currency', () => import(/* webpackChunkName: "billing" */ './components/billing/ChangeCurrency.vue'));
    Vue.component('manage-payment-method', () => import(/* webpackChunkName: "billing" */ './components/billing/ManagePaymentMethod.vue'));
    Vue.component('compare-price', () => import(/* webpackChunkName: "billing" */ './components/billing/ComparePrice.vue'));
} else if (pageClasses.classList.contains('page-premium-processing')) {
    Vue.component('stripe-payment-action', () => import(/* webpackChunkName: "billing" */ './components/billing/StripePaymentAction.vue'));
    Vue.component('progress-tracker', () => import(/* webpackChunkName: "billing" */ './components/billing/ProgressTracker.vue'));
} else if (pageClasses.classList.contains('page-thanks')) {
    Vue.component('circular-image-grid', () => import(/* webpackChunkName: "billing" */ './components/CircularImageGrid.vue'));
} else if (pageClasses.classList.contains('page-supported-games')) {
    Vue.component('games-page-search', () => import(/* webpackChunkName: "games-page" */ './components/GamesPageSearch.vue'));
}

const app = new Vue({
    el: '#app',
    name: 'app',
    data: {
        /**
         * Sub-components can fire an event updating the current game
         * id, then our watcher will fetch the actual game object and
         * trickle it down the line, updating subcomponents with the game
         */
        currentGame: {},
        currentGameId: 0,
        currentCategoryId: 1, // PC
        selectedCancelReason: null,
        subscriptions: (function () {
            // only execute the below steps when we're managing subscriptions
            if (typeof gameSubscriptions == 'undefined') {
                return false;
            }

            return gameSubscriptions;
        })(),
        showModal: false,
    },
    created: function () {
        if (this.isManagingSubscriptions() === false) {
            return;
        }

        this.$root.$on(EVENTS.SELECT_GAME, this.selectGame);
        this.$root.$on(EVENTS.SELECT_CATEGORY, this.selectCategory);
    },
    mounted: function () {
        // Fix any broken images on local dev env.
        this.fixLocalBrokenImages();

        // only execute the below steps when we're managing subscriptions
        if (this.isManagingSubscriptions() === false) {
            return;
        }

        // onload, select the current game
        this.$root.$emit(EVENTS.SELECT_GAME, this.currentCategoryId, this.currentGameId);
    },
    watch: {
        /**
         * Toggle the modalActive class when the modal is activated.
         * @param value
         */
        showModal: function(value) {
            if (!document.body.classList.contains('modalActive') && value == true) {
                document.body.classList.add('modalActive');
            } else {
                document.body.classList.remove('modalActive');
            }
        },
        /**
         * Whenever the game id changes, update the currentGame
         */
        currentGameId: function (value, oldValue) {
            self = this;
            let gameIndex = Object.keys(games).filter(function(item){
                return (games[item].id == self.currentGameId) ? true : false ;
            });
            this.currentGame = games[gameIndex];
        },
    },
    methods: {
        selectGame: function(categoryId, gameId, scrollToView = false) {
            if (typeof(gameId) === 'object') {
                gameId = gameId.id;
            }

            this.$root.$emit(EVENTS.CLEAR_ERRORS);

            this.selectCategory(categoryId);
            this.currentGameId = gameId;

            // select new game on the left-hand game list
            let newActiveGame = document.getElementById('miniGame-'+gameId);

            if (scrollToView && newActiveGame) {
                newActiveGame.scrollIntoView();
            }
        },
        selectCategory: function(id) {
          this.currentCategoryId = id;
        },
        isManagingSubscriptions: function () {
            return this.subscriptions !== false;
        },
        /**
         * Fix local broken images. Only run this on local dev env.
         */
        fixLocalBrokenImages: function() {
            if (window.location.hostname == 'local.patchbot-env.com') {
                this.replaceBrokenImagesWithPlaceholder();

                this.$nextTick(() => {
                    this.replaceBrokenImagesWithPlaceholder();
                });

                // Make sure we catch any images that load after the page is loaded.
                setTimeout(() => {
                    this.replaceBrokenImagesWithPlaceholder();
                }, 200);
            }

        },
        /**
         * Find and replace broken images with a placeholder image.
         */
        replaceBrokenImagesWithPlaceholder: function () {
            this.$el.querySelectorAll('img').forEach((img) => {
                if (img.closest('.embed')) {
                    return; // Skip images inside elements with the "embed" class
                }

                const replaceWithPlaceholder = () => {
                    const width = img.getAttribute('width');
                    const height = img.getAttribute('height');
                    if (width && height) {
                        img.src = `https://placehold.co/${width}x${height}`;
                    } else {
                        img.src = 'https://placehold.co/128x128';
                    }
                };

                if (img.naturalWidth === 0) {
                    replaceWithPlaceholder();
                }

                img.onerror = replaceWithPlaceholder;
            });
        },
    },
});

// Fire the app actions.
initHamburgerMenu();
initSidebar();
initAnimations();

/**
 * Make sure ajax request don't get captured by our CSRF protection
 */
if (Vue.hasOwnProperty('http')) {
    Vue.http.headers.common['X-CSRF-TOKEN'] = document.head.querySelector('meta[name="csrf-token"]').content;
}

